<app-dropdown
  [inputId]="inputId"
  [label]="label"
  [isFiltering]="isFiltering"
  [isMultiSelect]="isMultiSelect"
  [isFullWidth]="isFullWidth"
  [isInvalid]="isInvalid"
  [isDisabled]="isDisabled"
  (openingMenu)="onOpeningMenu()"
  (doneFiltering)="onDoneFiltering()"
>
  <app-menu-input
    searchContent
    [inputId]="inputId"
    [name]="name"
    [label]="label"
    [isDisabled]="isDisabled"
    [resetSearch]="!isFiltering"
    [placeholder]="
      this.selectedOptions.length > 0
        ? this.selectedOptions.length + ' Selected'
        : placeholder
    "
    [isSearch]="true"
    (searchValueUpdated)="onSearchValueUpdated($event)"
  ></app-menu-input>

  <ul menuContent class="multiselect-dropdown">
    <li *ngFor="let group of menuOptionGroups" class="group">
      <ul class="group-menu">
        <li
          class="no-results"
          *ngIf="group.options?.length === 0; else hasOptions"
        >
          No results found.
        </li>
        <ng-template #hasOptions>
          <li *ngFor="let option of group.options" class="group-menu-item">
            <input
              type="checkbox"
              [id]="getUniqueId(option, group.name)"
              [value]="option"
              [checked]="isOptionChecked(option)"
              (change)="onSelectionChange(option)"
            />
            <label
              [for]="getUniqueId(option, group.name)"
              class="group-menu-item-label"
              [innerHTML]="option.label"
            ></label>
          </li>
        </ng-template>
      </ul>
    </li>
    <ng-container *ngFor="let group of disabledGroup">
      <li class="header">{{ disabledLabel }}</li>
      <li *ngFor="let option of group.options">
        <span>
          {{ option.label }}
          <lib-icon name="lock"></lib-icon>
        </span>
      </li>
    </ng-container>
  </ul>
</app-dropdown>
